import { Box, Card } from '@mui/material';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from '@vidstack/react/player/layouts/default';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import Editor from '@/components/tiptap/Editor';

export default function VideoItem({ item }) {
  console.log(item);
  return (
    <Card sx={{ flex: 1, minWidth: 0 }}>
      {item.video && (
        <MediaPlayer
          title={item.title}
          src={item.video}
          style={{ borderRadius: 0, display: 'block' }}
        >
          <MediaProvider />
          <DefaultVideoLayout
            thumbnails={item.thumbnails}
            icons={defaultLayoutIcons}
          />
        </MediaPlayer>
      )}
      {item.image && !item.video && (
        <Box
          component="img"
          src={item.image}
          alt={item.title}
          sx={{ width: '100%', height: 'auto' }}
        />
      )}
      {item.content && <Box sx={{ px: 3, pb: 2 }}>
        <Editor content={item.content} editable={false} />
      </Box>}
    </Card>
  );
}
